import React from "react";

const IssueDetailsCard = ({ details }) => {
  return (
    <div className="rounded-[0.625rem] px-4 sm:px-9 pt-3 pb-6 border border-light-blue">
      <h3 className="font-nonito_sans font-semibold text-[1.25rem] leading-[2.97rem] text-primary">
        Issue Details
      </h3>
      <hr className="h-[0.0625rem] bg-light-blue mb-[0.625rem]" />
      <div>
        <p className="font-inter font-normal text-sm text-content">
          {details?.complaintReason}
        </p>
        {/* Task Details */}
        <div className="mt-6">
          {/* Mobile layout */}
          <div className="flex flex-col gap-2 sm:hidden">
            <div className="flex justify-between items-center">
              <span className="text-[#0F161E] text-sm font-medium font-inter">
                Issue Date
              </span>
              <span className="text-[#4A4A4A] text-sm font-inter">
                {details?.createdAt?.split("T")[0]}
              </span>
            </div>
          </div>

          {/* Desktop layout */}
          <div className="hidden sm:flex gap-[2.125rem]">
            <div className="flex flex-col gap-1">
              <span className="text-[#0F161E] text-sm font-medium font-inter">
                Issue Date
              </span>
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-[#4A4A4A] text-sm font-inter">
                {details?.createdAt?.split("T")[0]}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IssueDetailsCard;
